import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'

type Props = React.ComponentProps<typeof components.MenuList>

const Container = styled.div`
  flex-grow: 1;
`

const LocationSearchFieldMenuList = (props: Props) => {
  const { children } = props

  return (
    <Container>{children}</Container>
  )
}

export default LocationSearchFieldMenuList
